import {convertDateToScheduleDateObj} from '../../../../../core/factories/recruitment/convertDateToScheduleDateObj';
import {ScheduleButton} from '../../ScheduleButton';

export type ScheduleDTO = {
  id: number;
  name: string;
  place: string;
  isRegistered: boolean;
  registeredCount: number;
  entryStart: string;
  entryEnd: string;
  eventStart: string;
  eventEnd: string;
  isEntryEndAllDay: boolean;
  isEventStartAllDay: boolean;
  isEventEndAllDay: boolean;
};

export const Schedule: React.FC<{
  schedule: ScheduleDTO;
}> = ({schedule}) => {
  const entryEnd = convertDateToScheduleDateObj(
    schedule.entryEnd,
    schedule.isEntryEndAllDay,
  );

  const eventStart = convertDateToScheduleDateObj(
    schedule.eventStart,
    schedule.isEventStartAllDay,
  );

  const eventEnd = convertDateToScheduleDateObj(
    schedule.eventEnd,
    schedule.isEventEndAllDay,
  );

  return (
    <li
      key={`schedule-${schedule.id}`}
      className="flex justify-between border-b-[1px] [&:nth-last-child(1)]:border-b-0 border-collapse border-line-1 pb-12 [&:nth-last-child(1)]:pb-0 mb-12 [&:nth-last-child(1)]:mb-0"
    >
      <div className="w-[calc(100%-145px)] pr-12">
        {schedule.name ? (
          <p className="text-base text-black-1 font-bold">{schedule.name}</p>
        ) : (
          <p className="text-base text-black-1 font-bold">日程</p>
        )}
        {eventStart && eventEnd && (
          <p className="text-sm text-black-1 leading break-all mt-4">
            日程:&nbsp;{eventStart?.year}/{eventStart?.month}/{eventStart?.day}(
            {eventStart?.dayOfWeek})
            {eventStart?.time ? ` ${eventStart?.time}` : ''}&nbsp;~&nbsp;
            {eventEnd?.year}/{eventEnd?.month}/{eventEnd?.day}(
            {eventEnd?.dayOfWeek}){eventEnd?.time ? ` ${eventEnd?.time}` : ''}
          </p>
        )}
        {eventStart && !eventEnd && (
          <p className="text-sm text-black-1 leading break-all mt-4">
            日程:&nbsp;{eventStart?.year}/{eventStart?.month}/{eventStart?.day}(
            {eventStart?.dayOfWeek})
            {eventStart?.time ? ` ${eventStart?.time}` : ''}
          </p>
        )}
        {schedule.place && (
          <p className="text-sm text-black-1 leading mt-[2px]">
            場所:&nbsp;{schedule.place}
          </p>
        )}
      </div>
      <div className="flex flex-col items-end justify-between">
        {(entryEnd || eventStart) && (
          <ScheduleButton
            scheduleId={schedule.id}
            isRegisteredInitial={schedule.isRegistered}
            registeredCountInitial={schedule.registeredCount}
          />
        )}
        {entryEnd && (
          <div className="flex justify-end mt-12">
            <p className="text-notification-1 leading">
              <span className="text-xl">
                {entryEnd?.month}/{entryEnd?.day}
              </span>
              <span className="text-base ml-4">({entryEnd?.dayOfWeek})</span>
              <span className="text-base ml-4">
                {entryEnd?.time && entryEnd.time}
              </span>
              <span className="text-sm ml-4">締切</span>
            </p>
          </div>
        )}
      </div>
    </li>
  );
};
